import styles from './TextSection.module.scss';

import cx from 'classnames';
import React, { FC, HTMLAttributes } from 'react';

import { ExternalLink, LinkVariant, Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { ButtonLinkV2 } from 'components/Button/ButtonLinkV2';
import { ContentLinkV2 } from 'components/ContentLinkV2/ContentLinkV2';
import { TextV2 } from 'components/TextV2/TextV2';
import { TextWithArrow } from 'components/TextWithArrow/TextWithArrow';
import { FlatEntry } from 'services/cms/flattenContentful';
import { toEntry } from 'services/cms/typesUtil';
import { Merchant } from './Merchant';
import { QuotesIcon } from './QuotesIcon';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';

interface ITextSectionProps extends HTMLAttributes<HTMLDivElement> {
  testimony: FlatEntry<Subject>;
  merchant: FlatEntry<Subject>;
  stats?: FlatEntry<Subject>;
  overrideQuotesColor?: boolean;
  noImage?: boolean;
  showCaseVariation?: boolean;
  showOverlay?: boolean;
}

export const TextSection: FC<ITextSectionProps> = ({
  testimony,
  merchant,
  stats,
  overrideQuotesColor,
  noImage,
  showCaseVariation,
  showOverlay,
  ...props
}) => {
  const { blurb, richBlurb } = testimony;
  const link = testimony.link as ExternalLink;
  const isArrowLink = link && link.variant === LinkVariant.ARROW_TEXT;
  const isButtonLink = link && link.variant !== LinkVariant.ARROW_TEXT;

  return (
    <figure
      className={cx(
        styles.textSection,
        noImage && styles.noImage,
        !noImage && styles.withImage,
        showCaseVariation && styles.isShowcase,
        showOverlay && styles.showOverlay,
      )}
      {...props}
    >
      <div className={styles.quoteSection}>
        <QuotesIcon useTextColor={overrideQuotesColor} />
        <TextV2
          className={styles.testimony}
          variant="modern-h4"
          isMarkdown
          value={blurb}
          tagName="blockquote"
        />
        <RichBlurb
          className={styles.testimony}
          document={richBlurb}
          noParagraph
          tagName="blockquote"
          textVariant="modern-h4"
        />
      </div>

      <div className={styles.cotainerBottom}>
        <div className={styles.merchantWrapper}>
          <Merchant entry={merchant} iShowcase={showCaseVariation} />

          {isArrowLink && (
            <ContentLinkV2 entry={toEntry(link)} hideTitle className={styles.link}>
              <TextWithArrow>{link.title}</TextWithArrow>
            </ContentLinkV2>
          )}
          {isButtonLink && <ButtonLinkV2 entry={toEntry(link)} hideTitle className={styles.link} />}
        </div>

        {stats && (
          <div className={styles.stats}>
            <TextV2 className={styles.statsTitle} value={stats.title} tagName="p" variant="modern-h2" />
            <TextV2
              className={styles.statsSubtitle}
              value={stats.subTitle}
              tagName="p"
              variant="modern-body-medium"
            />
          </div>
        )}
      </div>
    </figure>
  );
};
